import { DiceSettingEnum, GameSpeedSettings, MapSettingEnum, ModeSettingEnum } from '@colonist/types';
import { GameModeDataController, GAME_TIMER_OPTIONS } from '@colonist/shared-types';
import { RoomSettingConstants } from '@colonist/game-base-types';
import { isValueBoolean, isValueNumber, isValueNumberBetween, isValueNumericEnum } from '@colonist/validation';
import { MapDataController } from '../../../../shared/map_data/MapDataController.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { socket } from '../EntryShared.ts';
export class UIRoomSettingsController {
    static snapshotRoomSettings(roomState, sessionId) {
        if (!roomState.isHost(sessionId)) return;
        const gs = roomState.gameSetting;
        StorageWrapper.setRoomSettingsSnapshot({
            modeSetting: gs.modeSetting,
            mapSetting: gs.mapSetting,
            maxPlayers: gs.maxPlayers,
            hideBankCards: gs.hideBankCards,
            noTrolls: roomState.isNoTrollsGame(),
            victoryPointsToWin: gs.victoryPointsToWin,
            cardDiscardLimit: gs.cardDiscardLimit,
            diceSetting: gs.diceSetting,
            friendlyRobber: gs.friendlyRobber,
            gameSpeed: gs.gameSpeed
        });
    }
    static initRoomSettingFromLocalStorage(modeSetting) {
        var _ClientUserState_userState;
        const snapshot = UIRoomSettingsController.readSnapshot();
        if (snapshot == null) return;
        const savedMode = UIRoomSettingsController.readEnum(snapshot.modeSetting, ModeSettingEnum);
        if (savedMode != null) socket.roomClient.setGameMode(savedMode);
        const effectiveMode = savedMode !== null && savedMode !== void 0 ? savedMode : modeSetting;
        const savedMap = UIRoomSettingsController.readEnum(snapshot.mapSetting, MapSettingEnum);
        if (savedMap != null) {
            const mapData = MapDataController.getMapDataForMap(savedMap);
            var _mapData_compatibleGameModes_includes;
            const isMapCompatible = (_mapData_compatibleGameModes_includes = mapData === null || mapData === void 0 ? void 0 : mapData.compatibleGameModes.includes(effectiveMode)) !== null && _mapData_compatibleGameModes_includes !== void 0 ? _mapData_compatibleGameModes_includes : false;
            if (isMapCompatible) socket.roomClient.setMap(savedMap);
        }
        const savedMaxPlayers = snapshot.maxPlayers;
        if (isValueNumberBetween(savedMaxPlayers, RoomSettingConstants.MIN_PLAYER_COUNT, RoomSettingConstants.MAX_PLAYER_COUNT)) {
            const modeMax = GameModeDataController.getMaxAllowablePlayerCountForMode(effectiveMode);
            if (savedMaxPlayers <= modeMax) socket.roomClient.setMaxPlayers(savedMaxPlayers);
        }
        const savedHideBankCards = snapshot.hideBankCards;
        if (isValueBoolean(savedHideBankCards)) socket.roomClient.setHideBankCards(savedHideBankCards);
        const savedNoTrolls = snapshot.noTrolls;
        var _ClientUserState_userState_items_hasMembership;
        const hasMembership = (_ClientUserState_userState_items_hasMembership = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) !== null && _ClientUserState_userState_items_hasMembership !== void 0 ? _ClientUserState_userState_items_hasMembership : false;
        if (savedNoTrolls === true && hasMembership) socket.roomClient.toggleNoTrolls();
        const savedVictoryPointsToWin = snapshot.victoryPointsToWin;
        if (isValueNumber(savedVictoryPointsToWin)) {
            const clamped = Math.max(savedVictoryPointsToWin, RoomSettingConstants.MIN_VP_TO_WIN);
            socket.roomClient.setVictoryPointsToWin(clamped);
        }
        const savedCardDiscardLimit = snapshot.cardDiscardLimit;
        if (isValueNumber(savedCardDiscardLimit)) {
            const clamped = Math.min(Math.max(savedCardDiscardLimit, RoomSettingConstants.MIN_CARD_DISCARD_LIMIT), RoomSettingConstants.MAX_CARD_DISCARD_LIMIT);
            socket.roomClient.setCardDiscardLimit(clamped);
        }
        const savedDice = UIRoomSettingsController.readEnum(snapshot.diceSetting, DiceSettingEnum);
        if (savedDice != null) socket.roomClient.setDiceType(savedDice);
        const savedFriendlyRobber = snapshot.friendlyRobber;
        if (isValueBoolean(savedFriendlyRobber)) socket.roomClient.setFriendlyRobber(savedFriendlyRobber);
        const savedGameSpeed = UIRoomSettingsController.readEnum(snapshot.gameSpeed, GameSpeedSettings);
        if (savedGameSpeed != null) {
            const speedSettingToUse = UIRoomSettingsController.getSpeedSettingToUse(effectiveMode, savedGameSpeed);
            socket.roomClient.setGameSpeed(speedSettingToUse);
        }
    }
    static readSnapshot() {
        const raw = StorageWrapper.getRoomSettingsSnapshotRaw();
        if (raw == null || typeof raw !== 'object') return null;
        return raw;
    }
    static readEnum(value, enumType) {
        if (!isValueNumericEnum(value, enumType)) return null;
        return value;
    }
    static getSpeedSettingToUse(modeSetting, gameSpeedSetting) {
        const gameModeData = GameModeDataController.getModeDataForMode(modeSetting);
        if (gameModeData == undefined) return gameSpeedSetting;
        var _gameModeData_allowedGameTimers_find;
        const defaultSpeedSettingForMode = (_gameModeData_allowedGameTimers_find = gameModeData.allowedGameTimers.find((t)=>GAME_TIMER_OPTIONS[t].isDefault)) !== null && _gameModeData_allowedGameTimers_find !== void 0 ? _gameModeData_allowedGameTimers_find : gameModeData.allowedGameTimers[0];
        const isCurrentSpeedAllowed = gameModeData.allowedGameTimers.some((t)=>t === gameSpeedSetting);
        return isCurrentSpeedAllowed ? gameSpeedSetting : defaultSpeedSettingForMode;
    }
}
